// extracted by mini-css-extract-plugin
export default {"reportTable":"Reports__reportTable--x6gzCy","link":"Reports__link--lmqQn9","disabled":"Reports__disabled---CR3iF"};